export default __webpack_public_path__ + "static/users3-ecb4aa163f2baae2c8250f68a410bdfc.png";